import React from "react"

const Navbar = () => {
  return (

    <>
      <div className="section">
        <div className="container">
          <div className="navbar-wrapper">
            <div className="links-wrapper">
              <button ><a href="/">Home</a></button>
              <button > <a href="/#work">Programming </a></button>
              <button> <a href="/#artwork">Art </a> </button>
              <button ><a href="/#contact">Contact </a> </button>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Navbar
